export type Email = string;

export const emailValidation = ".+@.*\\..*";
